export default {
  login: {
    // 登錄頁面
    inputaccount: '請輸入帳號',
    inputpwd: '請輸入密碼',
    login: '登錄',
    lospass: '忘記密碼',
    openaccont: '開立帳戶',
    inputphonemail: '請輸入手機號碼/郵箱',
    recode: '請輸入驗證碼',
    nologin: '未登錄，請登錄後再試',
    verification: '發送驗證碼',
    newpass: '請輸入新密碼',
    pemainotnull: '手機號碼/郵箱不能為空',
    asave: '保 存',
    checkphoneemail: '請檢查手機號或郵箱是否正確',
    rulepass: '密碼格式為8-16位包含大小寫字母、數字、特殊字符',
    rulecode: '驗證碼格式不正確!',
    verinotnull: '驗證碼不能為空!',
    serviceerror: '服務異常,請聯繫客服!',
    tafter: 's後再試',
    serviceerr: '服務出錯,請聯繫客服!',
    acconly: '登錄帳號只能輸入手機號，交易帳號，郵箱',
    logsucc: '登錄成功',
  },
  home: {
    // 首頁
    logout: '退出登錄',
    customer: '聯繫客服',
    mcwebsite: '寶匯官網',
    welcome: '歡迎你!',
    racc: '真實帳戶',
    dacc: '模擬帳戶',
    ihome: '首頁',
    lastlog: '上次登錄',
    balance: '帳戶餘額',
    networth: '淨值',
    margin: '可用保證金',
    injection: '注資',
    withdraw: '取款',
    customerstatus: '代理客戶情況',
    todaynews: '今日動態',
    commissions: '新增傭金',
    newcust: '新增客戶',
    newdeposits: '新增入金',
    subordinate: '說明：以上為您名下全部客戶及下屬代理客戶變化情況總覽。',
    cdetails: '返傭明細',
    more: '更多',
    cinews: '注資動態',
    ordernum: '訂單號',
    amount: '金額',
    deposittime: '充值時間',
    depositmethod: '充值方式',
    status: '狀態',
    dynamics: '提款動態',
    fee: '手續費',
    applicationt: '申請時間',
    operation: '操作',
    cantapp: '取消申請',
    lateann: '最新公告',
    nodate: '暫無數據',
    mccs: '寶匯客服',
    equivalent: '模擬帳戶是一個等同於真實情境的演練場，但所交易的皆為虛擬資金，不可以提現。如果您已經掌握基本交易規則，啟動真實帳戶，開啟真正的投資里程吧！',
    perfected: '一方實戰場地，注資將不再受限制，賺取真金白銀後也可以立即提現。如果您已經掌握基本規則，完善身份資料，啟動真實帳戶試試身手吧！',
    buttonbelow: '點擊下面的按鈕，即可啟動模擬交易帳戶。',
    identity: '點擊下面的按鈕，完善身份資料，即可啟動真實交易帳戶。',
    araccount: '啟動真實帳戶',
    previous: '上一篇',
    next: '下一篇',
    iprotect: '為了更好地保障您的資金安全，首次入金前請先完成實名認證',
    goautht: '前往實名認證',
  },
  und: {
    // 名下用戶列表
    undername: '名下用戶列表',
    tracc: '交易帳號',
    acctype: '帳戶類型',
    regdate: '註冊日期',
    tinfom: '交易資訊',
    lowlevel: '修改下級返傭',
    lowlevels: '機構客戶升級',
    export: '匯出',
    cgrade: '客戶升級',
    rebate: '您在這裡設置下級代理客戶每種商品的返傭金額（返傭/手），不能超過您自己的返傭金額',
    cname: '客戶姓名',
    frebate: '外匯類返傭：',
    ulot: '美元/手',
    srebtae: '股票類返傭：',
    indexc: '指數類：',
    chinar300: '中華300返傭：',
    chinar50: '中華50返傭：',
    rebates: '其它指數返傭：',
    comclass: '商品類：',
    lgrebate: '現貨黃金返傭：',
    lsrebate: '現貨白銀返傭：',
    usoilrebate: '美國原油返傭：',
    ukoilrebate: '英國原油返傭：',
    cryrebates: '加密貨幣類返傭：',
    btccomm: '比特幣返傭：',
    otherrebates: '其他加密貨幣返傭：',
    cancel: '取 消',
    confirm: '確 定',
    Reset: '重置',
  },
  details: {
    // 名下使用者交易資訊
    inscustom: '代理客戶',
    ordcustom: '普通客戶',
    return: '返回',
    funinfo: '資金資訊',
    position: '持倉',
    balance: '餘額',
    networth: '淨值',
    tradtype: '交易品種',
    transetype: '交易類型',
    transets: '交易類型：',
    lotsize: '手數',
    opetime: '建倉時間',
    opeprice: '建倉價',
    closet: '平倉時間',
    closets: '平倉時間：',
    stoptake: '止損/止盈價',
    invfee: '庫存費',
    closeposition: '平倉',
    to: '至',
    startd: '開始日期',
    endd: '結束日期',
    choose: '請選擇',
    enterc: '請輸入內容',
    query: '查詢',
    proloss: '總盈虧',
    tataltrance: '交易量合計',
    lindgold: '現貨黃金：',
    lindgolds: '現貨黃金',
    usoil: '美國原油：',
    usoils: '美國原油',
    forexchange: '外匯：',
    china300: '中華300：',
    china50: '中華50：',
    china300s: '中華300',
    china50s: '中華50',
    lonsilv: '現貨白銀：',
    lonsilvs: '現貨白銀',
    britishoil: '英國原油：',
    britishoils: '英國原油',
    stock: '股票：',
    oindex: '其他指數：',
    btc: '比特幣：',
    otherbtc: '加密貨幣：',
    closepr: '平倉價',
    proloass: '盈虧',
    settlecomm: '結算傭金',
    settlecomms: '結算傭金（$）',
    ordnum: '訂單編號',
    ordite: '訂單商品',
    salet: '買賣類型',
    traclient: '交易客戶',
    insclients: '所屬機構客戶',
    ownrebate: '自己返傭標準',
    lowerlev: '下級返傭標準/止盈價',
    cumulateive: '累計入金',
    Cumulateivein: '累計出金',
    netdeposit: '淨入金',
    opetdate: '操作日期',
    opettype: '操作類型',
    amount: '金額（$）',
    amountr: '金額（￥）',
    lweek: '最近一周',
    lmonth: '最近一個月',
    lthrmon: '最近三個月',
    totaltra: '總交易量',
  },
  commiss: {
    comman: '傭金管理',
    ewallet: '電子錢包',
    comtype: '傭金結算類型',
    walletbal: '電子錢包（餘額）',
    transfermt4: '轉入MT5：',
    transferamo: '轉入金額：',
    amountomt4acc: '轉入MT5帳號的金額',
    submit: '提 交',
    tips: '溫馨提示',
    tips1: '錢包餘額可以入金到MT5帳戶，不收取任何費用。',
    tips2: '錢包餘額入金到MT5的操作，每日只能操作一次',
    lgus5: '轉入銀行卡時，最低金額必須≥$5',
    process: '您當前已經有一筆出金申請正在處理中...',
    vuedetail: '查看詳情',
    totalcomm: '總結算傭金',
    ownlow: '下級返傭標準',
  },
  report: {
    underreps: '名下客戶持倉報表',
    underrep: '報表',
    selecttype: '請選擇交易品種',
    ordnumber: '請輸入訂單號',
    entaccname: '請輸入交易帳號/客戶姓名',
    selecttt: '請選擇交易類型',
    totalposi: '持倉總筆數',
    totalposih: '持倉總手數',
    clientsta: '名下客戶平倉報表',
    totalnumposc: '平倉總筆數',
    totalnumposl: '平倉總手數',
    totalproloss: '總平倉盈虧',
    interest: '倉息',
    clifunstat: '名下客戶資金報表',
    entoptuser: '請輸入操作用戶',
    totalwithdra: '出金總筆數',
    totalnumdep: '入金總筆數',
    totalwitham: '出金總金額',
    totaldepam: '入金總金額',
    opttime: '操作時間',
    opeuser: '操作用戶',
    losscus: '名下客戶盈虧報表',
    totalnumtra: '交易總人數',
    tradet: '交易明細',
    travolstavar: '各品種交易量統計',
  },
  link: {
    pulllink: '推薦網址',
    tpsi: '溫馨提示:通常適用於在博客,論壇,聊天工具,網站,電郵這些地方使用。',
    copy: '複製',
    qqlink: '點擊“複製”後，將推薦網址複製 到QQ群或者發送給你的QQ好友',
    weblink: '將內容分享到您的微博、人人網、 空間，輕鬆體驗賺錢的樂趣',
    morelink: '點擊“複製”後，將推薦網址複製 到各大貼吧或者論壇',
    copysucc: '複製成功！',
  },
  basic: {
    realname: '實名認證',
    idpic: '證件圖片',
    upload: '點擊上傳',
    carderr: '卡證文字識別失敗，您可以重新上傳圖片再次嘗試，或手動填寫身份資料，走人工審核通道。',
    manent: '手動輸入資料',
    cheinfo: '請核對如下資訊，如與您提交的證件資訊不符，可嘗試重新提交圖片，或手動修改，走人工審核通道。',
    repairre: '修改識別結果',
    name: '姓名',
    certty: '證件類型',
    antwallet: '螞蟻錢包認證',
    identifie: '待識別',
    entname: '請輸入姓名',
    idnmu: '證件號碼',
    idcard: '身份證',
    passport: '護照',
    other: '其他',
    eveare: '請選擇活動區域',
    fairea: '失敗原因：',
    safety: '為了保障您的財產安全，請填寫真實身份資料資訊；',
    completing: '完成實名認證及銀行卡綁定後，方可申請提現；',
    max5m: '圖片格式：支援jpg/png/jpeg格式，圖片大小不超過5M。',
    Resubmit: '重新提交',
    automatic: '您的身份資料未能通過自動校驗，您可以選擇：',
    resubinfo: '核對並修改資料，重新提交；',
    correct: '如果確認資料無誤，請走人工審核通道，客服人員會儘快協助您解決此問題',
    cheinfomation: '核對資料',
    subman: '提交人工審核',
    onlineservice: '認證失敗，如有疑問請聯繫線上客服',
    onlinecusser: '線上客服',
    entidnum: '請輸入證件號碼',
    entcorrect: '請輸入正確的證件號碼',
    selectdoc: '請選擇證件類型',
    cardfront: '身份證正面',
    cardback: '身份證反面',
    upfrontcard: '請上傳身份證正面',
    upbackcard: '請上傳身份證反面',
    notverified: '未認證',
    verifica: '待審核，請等待...',
    verpass: '審核通過',
    verfailed: '審核未通過',
    otherdocu: '其它證件',
    sizemax5m: '上傳頭像圖片大小不能超過 5MB!',
    frontdoc: '證件正面',
    backdoc: '證件反面',
    subing: '正在提交...',
    submit: '提交',
    allup: '請檢查證件照片是否全部上傳',
    verwait: '驗證中,請稍等...',
    logexp: '登錄過期，請重新登錄',
    statement_text_title: '重要聲明：',
    statement_text:
      '填寫本問卷表示客戶本人已接受風險承受能力的問卷調查，完全知悉所投資產品的風險類別，且客戶本人所作出的所有投資決定，均是基於客戶本人的判斷，並無條件承諾自行承擔一切投資風險和相關責任。',
    toast: '問卷信息未填寫完',
    nav_title: '交易評估表',
    tip_text: '提交審核文件前，為了確保您已經了解CFD產品交易的相關風險以及判斷自身投資的情況，請根據您目前的狀況填寫以下表格：',
    van_button: '確認提交',
  },
  bank: {
    bankcard: '銀行卡：',
    name: '姓名：',
    idnumber: '證件號碼：',
    banknumb: '銀行卡號：',
    entbankcard: '請輸入銀行卡號',
    bankname: '銀行名稱：',
    bankloca: '銀行所在地區: ',
    bankbran: '分/支行名稱: ',
    bankphon: '請填寫銀行預留手機號：',
    entbranch: '請用英文填寫分/支行名稱',
    entbranchs: '請填寫分/支行名稱',
    entbankmob: '請輸入銀行預留手機號',
    bic: '請輸入Sort code/SWIF/BIC',
    entcorr: '請輸入正確的手機',
    bankima: '銀行卡圖片',
    proacco: '銀行資料將會作為您提現的收款帳戶，為保障您的資金安全，請確保資訊準確無誤；',
    banksub: '銀行資料一經提交成功，便無法自行修改，若要變更，請',
    contactcus: '聯繫客服',
    combind: '請先完成實名認證，再綁定銀行卡！',
    entdigit: '請輸入銀行卡號',
    selregion: '請選擇銀行所在區域',
    entbankname: '請輸入銀行名稱',
    entbanknames: '請用英文填寫銀行名稱',
    name2to50: '分支行名稱在 2 到 50 個字',
    upphoto: '請上傳銀行卡正面照片',
    notverif: '未審核',
    verified: '已認證',
    failveri: '審核失敗',
    upfrontimag: '請先上傳銀行卡正面圖片',
    Confirm: '確定',
    choose: '請選擇',
    state_text: ['待審核', '審核通過', '審核未通過'],
    noDataText: '您還沒有綁定銀行卡',
    unbind_message: '確定要刪除該銀行卡嗎？',
    updateSuccess: '設置成功',
    add_bank: '添加銀行卡',
    default: '默認',
    default_button: '設為取款到賬卡',
    unbind: '解除綁定',
  },
  paw: {
    chapass: '修改密碼',
    entnewpass: '輸入新密碼：',
    entpassagain: '再次輸入新密碼：',
    againentpass: '請再次輸入新密碼',
    vercode: '驗證碼：',
    bindphonef: '請先綁定手機或郵箱',
    notmatch: '兩次輸入密碼不一致!',
    reasec: '秒後重新獲取',
    getverifi: '獲取驗證碼',
  },
  dep: {
    Injection: '注資',
    capamoun: '注資金額',
    Dollar: '美元',
    d600: '600美元',
    d500: '500美元',
    d300: '300美元',
    d200: '200美元',
    traaccount: '交易帳戶:',
    equal: '約等於',
    rmb: '人民幣',
    avaliable: '今日還可注資',
    time: '次',
    madeonce: '模擬帳戶每天可注資一次,每次10000美元；',
    amountrmb: '人民幣金額僅供參考；',
    capitalinj: '此處注資金額為虛擬資金,只能用於模擬交易,不能提現。',
    doubt: '如有疑問,請聯繫',
    call24line: '或撥打24小時服務熱線',
    next: '下一步',
    selmet: '選擇支付方式',
    WeChat: '微信',
    Alipay: '支付寶',
    paid: '實付',
    return: '返&nbsp;&nbsp;&nbsp;&nbsp;回',
    payimm: '立即支付',
    complete30: '請在30分鐘內完成支付，逾時訂單將被關閉；',
    ifexit: '如果當日存在',
    tran3: '3筆',
    notpaid: '未支付訂單，當日將被限制使用網上存款功能；',
    platnotacc: '本平臺不接受來自協力廠商的注資，暫不支持信用卡注資；',
    allaccset: '本平臺帳戶均為美元結算，人民幣換算結果僅供參考，以支付平臺即時匯率轉換結果為准，建議預留匯率浮動空間，以確保您的投資需求；',
    herebycon: '本人確認為帳戶合法持有人，並確認存入資金與任何非法活動無關；',
    hereconlegal: '本人承諾再次用於注資的銀行卡屬於本人合法持有，所有注資均由本人操作。',
    entamount: '請輸入金額',
    single50: '單筆注資為50到700美金',
    incamount: '金額格式不正確',
  },
  wit: {
    getmet: '正在獲取取款方式',
    perpat: '個人資訊正在審核，請耐心等待...',
    tipens: '提示：為保障您的資金安全，提現前請先完成以下資料認證！',
    available: '可提取金額：',
    withdraw: '提取金額：',
    conrmb: '換算人民幣：',
    huansuan: '换算USDT',
    witmeth: '取款方式：',
    selwithdra: '請選擇取款方式',
    uping: '上傳中...',
    wechatpay: '獲取微信收款碼方式：',
    click: '點擊',
    me: '我',
    pay: '支付',
    collpay: '收付款',
    qrcode: 'QR Code收款',
    setamount: '設置金額',
    entrmb: '輸入“換算人民幣”展示金額',
    cliok: '點擊確定',
    reccode: '然後截圖收款碼',
    withqrcode: '您可以通過上傳微信收款QR Code來提現',
    alicode: '獲取支付寶收款碼方式：',
    withdrawqr: '您可以通過上傳支付寶收款二維碼來提現',
    payqracc: '收款二維碼需要附帶金額，不然可能無法通過申請哦！',
    actualdiff: '實際到帳會因合作商戶提供管道有不同，若此支付方式暫無服務亦可能以您的綁定銀行卡到帳。',
    nohand: '當月首筆出金免手續費；',
    lessthan: '當月第二筆及以上出金，如出金額＜100美元，需扣除5美元手續費；',
    current: '當前有未完成出金訂單，則無法提交新的出金申請；',
    succdep: '24h之內有成功入金，無法申請出金；',
    withdrawal: '取款將於財務部門服務時間（工作日09：00-18：00）審核匯出，一般在1個工作日內到帳；具體到帳時間仍需視乎銀行處理速度，約1-3個工作日到帳。',
    less50: '出金金額小於50美金，需要扣除3美元手續費；',
    sessdeposit: '總交易金額不足總入金金額的',
    necessary: '則需要扣除本次出金金額的',
    asfee: '做為手續費；',
  },
  fun: {
    details: '資金明細',
    capital: '注資總額：',
    Date: '日期',
    Time: '時間',
    Times: '時間',
    staope: '狀態/操作',
    totalwithdra: '提現總額：',
    wdrawamount: '提現金額',
    arrrmb: '實際到帳人民幣',
    withdrawal: '取款方式',
    address: '到帳錢包地址:',
    apptime: '申請提交時間',
    Cancel: '取消',
    Details: '詳情',
    orddetail: '訂單詳情',
    pendingver: '待審核',
    verifying: '審核中',
    wisuccess: '出金成功',
    wifaile: '出金失敗',
    ordcannel: '訂單取消',
    ordernumb: '訂單號：',
    widrawam: '提現金額：',
    hfee: '手續費：',
    appsubtime: '申請提交時間：',
    orderstatus: '訂單狀態：',
    remark: '備註：',
    remarks: '備註',
    All: '全部',
    ondep: '網上存款',
    banktrn: '銀行匯款',
    Mallpayment: '商城支付',
    QuickPayment: '快捷支付',
    Depositonline: '網上充值',
  },
  pos: {
    posi: '持倉',
    travar: '交易品種：',
    buy: '買入',
    sell: '賣出',
    holdtime: '持倉時間：',
    occ: '佔用保證金',
    curt: '當前交易記錄',
    Notes: '注釋',
    closeto: '平倉盈虧',
    notparti: '您還沒有參加此活動',
    gotodep: '前往充值，領取獎勵',
    actname: '活動名稱：',
    acttime: '活動時間：',
    '72hdep': '72小時淨入金：',
    cashrew: '美元現金獎勵等級：',
    ucrels: '美元現金發放狀態：',
    rewlev: '實物獎勵等級：',
    rediss: '實物獎勵發放狀態：',
    nameact: '活動名稱：',
    timeact: '活動時間：',
    recaward: '聯繫客服領獎',
    rewdistr: '實物獎勵發放時間：',
    rewactdi: '實物獎勵實際發放物品：',
    pending: '待定級',
    pendingr: '待發放',
    issued: '已發放',
    expired: '已過期',
    notstandard: '未達標',
    grouped: '待分組',
    notissued: '未發放',
    expired1: '已失效',
  },
  down: {
    softdown: '軟體下載',
    downmt4: '下載MT5交易軟體/寶匯投資APP，即刻開始交易',
    mt4trad: 'MT5交易平臺',
    mt4prof:
      'MT5是一款可同時交易外匯、貴金屬的專業交易軟體。其綜合了行情圖表、技術分析、交易操作三大功能於一身，可進行下單、平倉限價單、止損、止贏、查看報表及分析資料等不同操作，是目前最為廣泛使用的外匯行情軟體之一。目前在全球超過300家經紀商及銀行正在使用MT5平臺作為交易平臺，是全球最受歡迎的線上交易平臺。',
    insquot: '提供即時報價',
    simpflex: '簡易操作、下單靈活',

    riskfun: '具備止損獲利等風險控制功能',
    lockfun: '具備鎖倉功能',
    charts: '價格圖表清晰直觀',
    intuitive: '畫圖工具及技術分析指標方便易用',
    install: '安裝便捷，佔用系統資源小',
    versiond: 'MT5 PC版下載',
    scanqr: '掃描QR Code下載移動端',
    mcappcon:
      '寶匯投資APP是我們公司為客戶精心打造的一款手機行情軟體，在這裡您能得到全方位的國內外貴金屬行情、國內外期貨行情、全球指數、財經資訊等服務。炫酷的頁面設計，極快的資料傳輸速度、流暢的體驗加上其強大的資料資訊，能夠為您提供更準確更即時的財經資料、行情報價，以及獨家解盤評論，讓您不論身在何處都可以運籌帷幄，享受智盈人生。',

    marketany: '隨時隨地查看行情資料，資料傳輸快速穩定',
    comprehensive: '全面客觀的技術分析總結和建議',
    economy: '宏觀經濟面瞭解經濟狀況',
    quickopen: '快速開戶，即時登錄注資取款',
    onemachine: '一機在手，交易無憂',
    macapp: '寶匯投資APP',
  },
  sug: {
    acom: '提交投訴建議',
    dissatisfied: '如果您對我們的服務有不滿之處，請在此提交留言，我們會儘快給予答覆或處理，謝謝！',
    title: '標題：',
    enttile: '請輸入標題',
    comtype: '投訴類型：',
    seltype: '請選擇投訴類型',

    sersug: '服務改善建議',
    complain: '投訴客戶服務',
    problem: '交易帳號問題',
    deposits: '帳戶資金存取',
    website: '網站推廣/客服',
    orderap: '交易訂單申訴',

    visit: '回訪類型：',
    onlinemeg: '線上留言',
    spe: '專人回電',
    appointment: '預約時間：',
    sappointment: '請選擇預約時間',
    content: '內容：',
    contentc: '內容',
    entres: '請輸入預留資訊',
    comret: '投訴建議回訪',
    moddate: '修改日期：',
    selvisit: '請選擇回訪類型',
    subtime: '提交時間',
    type: '類型',
    Reply: '回復',
    notpro: '未處理',
    replyd: '已回復',
    over: '已結束',
    sappointments: '請選擇預約時間！',
    blank: '標題不能為空！',
    thanks: '感謝您的關注和回饋,我們的工作人員稍後會和您聯絡,請保持手機暢通,祝您生活愉快!',
    subsucc: '提交成功',
  },
  msg: {
    announ: '公告',
    staletter: '站內信',
    contactus:
      '寶匯投資是專業的外匯及差價合約交易平臺，領有賽普勒斯證券交易委員會牌照（CySEC） , 牌照號:299/16。通過行業監管，加強保障顧客資金安全的同時，致力為全球投資者提供多元化的綜合性投資服務,包括外匯、指數、原油、貴金屬、美股等杠杆式差價合約交易。',
    contactus2:
      '寶匯投資擁有先進的MT5電子交易平臺系統及自行研發交易APP軟體，投資者可參與到規模巨大的國際投資市場，快速執行交易，斬獲利潤。從報價到成交，均嚴格規範、透明度高。同時投資者可在同一平臺全面、靈活地管理不同投資產品，滿足各種不同投資者的需求。',
    contactus3: '此外，公司還擁有7*24小時的服務團隊，隨時為投資者解決投資過程中遇到的疑惑，給您最佳的投資體驗！',
    coninfo: '聯繫方式：',
    cusemail: '客服郵箱：cs@prowayxau.com',
    custeleph: '客服電話：4008423990',
    statistics: '代理客戶數：',
    comcus: '普通客戶數：',
    totaldep: '總入金：',
    totalde: '總入金',
    totalwit: '總出金：',
    totalwi: '總出金',
    totalreb: '總返傭：',
    totalre: '總返傭',
    report: '*此報表展示該客戶名下整條代理鏈的加總數據(包含客戶自己)，非客戶個人資料。',
    numcus: '客戶數',
    loginout: '是否確定退出用戶中心?',
    tryagain: '請重試',
    notsub: '非工作時間，暫時無法提交出金',
  },
  menu: {
    ib: '代理客戶專區',
    sib: '名下用戶',
    stics: '名下使用者資料統計',
    sions: '傭金管理',
    repview: '報表預覽',
    rlink: '推薦網址',

    ainfo: '帳戶資料',
    poi: '實名認證',
    bard: '銀行卡',
    cpass: '修改密碼',

    mmange: '資金管理',
    injects: '注資',
    widraw: '取款',
    fdet: '資金明細',
    qbdz: '錢包地址管理',
    tradi: '交易資訊',
    posit: '持倉',
    closep: '平倉',
    actcen: '活動中心',
    firste: '首充活動',
    servce: '服務中心',
    down: '軟體下載',
    sugge: '投訴建議',
    mymess: '我的消息',
    conus: '聯繫我們',

    invfri: '邀請好友',
    invfris: '活動主頁',
    bonus: '獎勵明細',
    setrec: '結算記錄',

    firseven: '首充活動',
    bemail: '綁定郵箱',
    changephone: '更換綁定手機',
    uc: '用戶中心',
    activityList: '活動大廳',
    myActivity: '我的活動',
    activityDetail: '活動詳情',
  },
  meta: {
    base: '用戶中心',
    phonotblank: '手機號碼不能為空',
    corrpho: '請輸入正確的手機號碼',
    entcode: '請輸入正確的驗證碼',
    entemail: '請輸入郵箱位址',
    gpver: '前往驗證',
    fillmail: '請填寫正確的郵箱',
    emailnotnull: '郵箱不能為空',
    querstion: '，如有疑問，請聯繫線上客服',
    bounde: '已綁定郵箱',
    chaemail: '修改郵箱',
    entnewpho: '請輸入新的手機號碼',
    chapho: '修改綁定手機',
    setp1: 'Step1 驗證身份',
    step2: 'Step2 綁定新手機',
    currentpho: '當前綁定手機',
    cuurn: '已綁定手機無法接收驗證碼',
    authcurr: '使用當前綁定手機驗證身份',
    phobound: '手機號已綁定',
    failedem: '郵箱驗證失敗，如有疑問，請聯繫線上客服',
    phobeenbound: '手機號碼已註冊',
    Reminder: '溫馨提示：驗證碼已發送至您的郵箱',
    mailbox: '請前往郵箱查看',
    boundsucc: '完成綁定',
  },
  active: {
    score: '我的成績',
    title_span_1: '盈虧金額',
    title_span_2: '預計可提現',
    resetButton: '申請重置活動',
    h4_title: '活動詳情',
    status: '活動狀態:',
    starttime: '開始時間:',
    endtime: '結束時間:',
    resetnum: '剩餘重置次數:',
    rstprofit: '盈虧:',
    balance: '帳戶餘額:',
    award: '獎勵餘額:',
    Invalid: '錯誤請求，請聯繫管理員',
    failed: '請求失敗，請聯繫管理員',
    size5: '上傳圖片大小不能超過 5MB!',
    upfail: '上傳失敗',
    failgetimg: '獲取圖片位址失敗',
    Scantopay: '充值碼支付',
    infver: '資料認證',
    china: '中國(大陸)',
    activityStatus: ['進行中', '已結束', '報名中'],
    detailsState: ['進行中', '已完成'],
  },
  banck: {
    addcard: '添加銀行卡',
    cardholder: '持卡人姓名：',
    bankpro: '銀行所在地區：',
    Branch: '分/支行名稱：',
    submitting: '提交後客服將對您的銀行卡資料進行認證審核，只有審核通過的銀行卡才能用於提現；',
    approved: '銀行資料一經提交成功，便無法自信修改，若要變更，請聯繫客服；',
    funding: '銀行卡資料關係到您的資金安全，請確保資訊準確無誤。',
    digit: '請輸入銀行卡號',
    phonenum: '請輸入手機號碼',
    digit11: '請輸入手機號碼',
    otherbanks: '其他銀行',
    bankinfoma: '銀行卡資料',
    shared: '共有',
    verify: '張銀行卡/最多可綁定',
    piece: '張',
    Reserved: '預留手機號',
    Safestate: '安全狀態',
    Remove: '解綁',
    bankdetail: '銀行卡詳情',
    BankName: '開戶行：',
    cardholde: '持卡人：',
    Reserve: '預留手機：',
    Verification: '綁定時間：',
    cerstatus: '認證狀態：',
    keepone: '至少保留一張認證卡',
    curcontinue: '此操作將從列表刪除當前銀行卡, 是否繼續?',
    Note: '提示',
    remsuc: '解綁成功!',
    Cancelled: '已取消解綁',
    ver3card: '最多綁定三張銀行卡',

    bindexist: '綁定已有的真實帳戶',
    bindexistd: '綁定已有的模擬帳戶',
    acc: '帳號',
    entyacc: '請輸入帳號',
    password: '密碼',
    bindnow: '立即綁定',
    actdemoacc: '啟動模擬帳戶',
    virtra: '是一個虛擬的網上交易帳號，帳戶中的資金為虛擬，商品、報價、圖表、買賣等均與真實交易系統即時同步，是新手入門貴金屬交易的最佳演練場。',
    Realname: '真實姓名',
    entyourrn: '請輸入真實姓名',
    China: '中國大陸',
    chihk: '中國香港',
    chimac: '中國澳門',
    chitw: '中國臺灣',
    othcoun: '其他國家及地區',
    setpassword: '設置密碼',
    promnum: '推薦代碼',
    entpronum: '請輸入推薦代碼（非必填）',
    mobilephone: '手機',
    noacctoopen: '無真實帳戶，馬上去啟動',
    nodemoacc: '無模擬帳戶，馬上去啟動',
    notblank: '姓名不能為空',
    incfor: '姓名格式不正確!',
    idnumnotblank: '證件號碼不能為空',
    entidcorr: '請正確輸入證件號碼!',
    idbeenreg: '證件號碼已被註冊!',
    pasnotempty: '密碼不能為空',
    invformat: '帳號格式錯誤',
    pass6: '密碼最少6位元',
    youaccis: '您的真實帳號為',
    activation: '啟動成功',
    demoacc: '您的模擬帳號為',
    inviterew: '邀請獎勵',
    Invitee: '被邀請人：',
    nameacc: '請輸入姓名/交易帳號',
    invnumb: '邀請人數/人',
    activenump: '啟動人數/人',
    trewards: '交易獎勵',
    continutrading: '連續交易獎勵',
    rewards: '產生獎勵',
    inviterews: '被邀請獎勵',
    bindinvcode: '綁定邀請碼：',
    enterinvite: '請輸入邀請碼',
    bind: '綁定',
    Invitepeople: '邀請人',
    Rewconsecutive: '已達成連續交易獎勵',
    Eightweek: '八周交易手數統計',
    Eightweekcou: '八周倒計時',
    BasicInfor: '基本資訊',
    accoptime: '開戶時間',
    earntime: '收入時間',
    gentrarewards: '已產生交易獎勵',
    day180lots: '180天內交易手數',
    day180down: '180天倒計時',
    Continuous: '連續',
    weeklots: '周平倉手數均',
    cangethand: '手時，雙方均可獲得',
    invcodenotempty: '邀請碼不能為空',
    earnedon9: '每天上午9:00 結算前一日獎勵',
    accumrews: '累計獲得獎勵',
    rewardsstet: '待結算獎勵',
    rewandsetl: '獎勵與結算',
    numofinvite: '邀請人數',
    yesterdayrew: '昨日結算獎勵',
    promocode: '我的推薦代碼',
    clicksave: '點擊保存QR Code',
    promotion: '您的推薦代碼為',
    copypromo: '點擊複製推薦代碼',
    promolink: '您的推薦網址為',
    copylink: '點擊複製推薦網址',
    procodebind: '推薦代碼：複製後發送給被邀請人，被邀請人在用戶中心綁定即可；',
    prolinkcopy: '推薦網址：複製後發送給被邀請人，被邀請人通過網址開戶成功自動綁定；',
    qrcodesave: 'QR Code：點擊QR Code保存圖片，被邀請人掃描開戶成功後自動綁定。',
    accnotactive: '帳戶尚未啟動，無法使用推薦功能',
    activatedt: '啟動帳戶，啟用我的推薦代碼',
  },
  set: {
    settleteime: '結算時間',
    setamo: '結算金額',
    stpset: 'STP設置',
    ecnset: 'ECN設置',
    indexclass: '指數類',

    frebate2: '外匯類返點：',
    srebtae2: '股票類返點：',
    chinar300s: '中華300返點：',
    chinar50s: '中華50返點：',
    rebates2: '其它指數返點：',
    comclass2: '商品類：',
    lgrebate2: '現貨黃金返點：',
    lsrebate2: '現貨白銀返點：',
    usoilrebate2: '美國原油返點：',
    ukoilrebate2: '英國原油返點：',
    cryrebates2: '加密貨幣類返點：',
    btccomm2: '比特幣返點：',
    otherrebates2: '数字货币貨幣返點：',
    Group: '用戶組別',
    groper: '組別許可權',

    ukoilrab: '請輸入英國原油返點',
    correbate: '請輸入正確的英國原油返點金額',
    entcha300: '請輸入中華300返點',
    entcorcha300: '請輸入正確的中華300返點金額',
    entcha50: '請輸入中華50返點',
    entcorcha50: '請輸入正確的中華50返點金額',
    entusoilr: '請輸入美國原油返點',
    encortusoilr: '請輸入正確的美國原油返點金額',
    entfxr: '請輸入外匯類返點',
    entcorfx: '請輸入正確的外匯類返點金額',
    entxauusd: '請輸入現貨黃金返點',
    entcorxauusd: '請輸入正確的現貨黃金返點金額',
    entothindex: '請輸入其它指數返點',
    entcorindex: '請輸入正確的其它指數返點金額',
    entxagusdr: '請輸入現貨白銀返點',
    entcorxagusd: '請輸入正確的現貨白銀返點金額',
    stockrebate: '請輸入股票類返點',
    entcorstock: '請輸入正確的股票類返點金額',
    btc100rebate: '請輸入比特幣返點',
    btc100cor: '請輸入正確的比特幣返點金額',
    otherrebate: '請輸入其他加密貨幣返點',
    corofcrypt: '請輸入正確的其他加密貨幣返點金額',

    ukoilrebate: '英國原油返點不能大於上級返點',
    chi300: '中華300返點不能大於上級返點',
    chi50: '中華50返點不能大於上級返點',
    usoilrebate: '美國原油返點不能大於上級返點',
    fxrebate: '外匯類返點不能大於上級返點',
    xauusdrebate: '現貨黃金返點不能大於上級返點',
    stockrebates: '股票類返點不能大於上級返點',
    btc100rebates: '比特幣返點不能大於上級返點',
    cryptos: '其他加密貨幣返點不能大於上級返點',
    indexrebates: '其它指數返點不能大於上級返點',
    xagusdreabage: '現貨白銀返點不能大於上級返點',

    pre: '上一篇',
    next: '下一篇',
    trebates: '總返點',
    promocode: '推薦代碼 ',

    sotr: '結算總返傭',
    sor: '結算返點$',
    soc: '結算返傭$',
    ss: '結算狀態',
    rr: '返點標準',
    cry: '加密貨幣類',
    stpview: '點擊查看合約細則',
    ecnview: '點擊查看合約細則',
    reflink: '推薦網址:',

    stpnocom: 'STP標準帳號/無手續費',
    stp10usd: 'STP標準帳號/每手10USD手續費',
    stp20usd: 'STP標準帳號/每手20USD手續費',
    stp30usd: 'STP標準帳號/每手30USD手續費',
    stp40usd: 'STP標準賬/每手40USD手續費',
    stp50usd: 'STP標準帳號/每手50USD手續費',
    ecnlowspread: 'ECN低點差帳號/每手10USD手續費',
  },
  fx: {
    Forex: '外匯類',
    Stock: '股票類',
    index: '指數類',
    btc: '比特幣',
    otherbtc: '加密貨幣',
    Commission: '總返傭',
    deposit: '入金',
    withdraw: '出金',

    withd: '請先選擇取款方式',
    failedobtbank: '獲取銀行卡資訊失敗，請刷新頁面重試',
    failedobt: '獲取幣位址資訊失敗，請刷新頁面重試',
    fristup: '請先上傳收款碼',
    insbal: '餘額不足',
    balove: '餘額超時',
    conf: '請確認',
    mt4suc: 'MT5成功',
    processing: '正在出金',
    min5: '最小金額為$5',
    correctamo: '請填入正確金額',
    maxamount: '可提取金額最大為',
    errgetbal: '獲取餘額失敗',
    faildcny: '獲取提現人民幣失敗',
    wallet: '數字錢包',
    nodemoac: '暫時沒有模擬帳號',
    suc: '密碼修改成功!',
    tout: '登錄過期，請重新登錄',
    numofdircli: '直屬客戶數：',
    numofsubid: '下級客戶數：',
    recivemail: '驗證碼已發送，請登錄查看',
  },
  wal: {
    def: '默認',
    noadd: '無地址',
    add: '添加',
    rightadd: '請確保您提供的地址正確，因錢包地址錯誤而導致的財產損失，將由客戶個人承擔。',
    edit: '編輯',
    del: '刪除',
    address: '地址',
    addadr: '添加新地址',
    chain: '鏈名稱',
    wal: '錢包地址',
    waladd: '請輸入錢包地址',
    com: '為便於地址管理及使用,可添加簡要說明',
    defadd: '設為默認到帳錢包地址',
    riaddr: '請輸入正確的鏈地址！',
    edadd: '編輯地址',
    addaddr: '新增地址',
    deladdr: '您是否要刪除此收幣地址?',
    sucdel: '刪除成功!',
    chaalr: '已取消刪除',
    alre: '已扣除未達標的活動預贈金',
    alre1: '',
  },
  act: {
    fbon: '預贈金',
    bonamount: '預贈金額：',
    lots: '交易手數：',
    stime: '開始時間：',
    etime: '結束時間：',
    prosta: '預贈金狀態:',
    nis: '未發放',
    isuse: '已發放',
    comp: '已達標',
    ded: '已扣回',

    gifta: '實物禮品',
    gift: '獎品：',
    giftstatus: '獎品狀態：',
    concus: '獲得禮品，聯繫客服!',

    nogroup: '未分組',
    noncon: '未達標',
    complate: '已完成',
    expi: '已失效',

    rece: '已獲得',
    notget: '未獲得',
    twbon: '臺灣首充活動',
    reces: '獎勵級別',
    depamo: '首入金額:',
    prost: '活動狀態: ',
    fdt: '首充時間:',
    cut72: '首充72小時:',
  },
  tra: {
    rtime: '報名時間:',
    etime: '活動到期時間:',
    lev: '當前獎勵級別:',
    gift: '交易有獎活動',
    over: '已結束',
    Dollar: '美元',
    limit: '1000美元以內出金只支持TRC20',
  },
}



// WEBPACK FOOTER //
// ./src/lang/tw.js